import { IWebchatSettings } from 'modules/webchat/domain/entities';

export default function buildWebchatSettings(
  uuid?: string,
  scriptToken?: string,
): IWebchatSettings | null {
  const trimmedUuid = uuid?.trim();
  const trimmedScriptToken = scriptToken?.trim();

  if (!trimmedUuid || !trimmedScriptToken) return null;

  return { uuid: trimmedUuid, scriptToken: trimmedScriptToken };
}
